import React, { PureComponent } from 'react';
import ItemSelect from '../../ItemSelect';
import CostDisplay from './CostDisplay';
import { calculatePizzaModifierBuilderCost } from '../utils';

import { getPizzaServingsList, getPizzaAmountsList } from '../utils';

class ModifierContentBuilder extends React.Component {
  handleServingChange = (event, value, item) => {
    this.onModifierBuilderChange('selected_serving', item);
  };

  handleAmountChange = (event, value, item) => {
    this.onModifierBuilderChange('selected_amount', item);
  };

  onModifierBuilderChange = (field, item) => {
    const { onChange } = this.props;
    if (onChange) onChange(field, item);
  };

  render() {
    const { modifier, partialServingPricing } = this.props;
    const pizzaAmounts = getPizzaAmountsList(modifier.cost);
    const pizzaServings = getPizzaServingsList(partialServingPricing);
    const builderCost = calculatePizzaModifierBuilderCost(
      modifier.cost,
      modifier.selected_amount,
      modifier.selected_serving
    );
    return (
      <div className="pizzaModifierContent">
        <div className="pizzaModifierContentHeader">{modifier.title}</div>
        {modifier.selected ? (
          <div className="pizzaModifierContent">
            <ItemSelect
              active={modifier.selected_amount}
              options={pizzaAmounts}
              onChange={this.handleAmountChange}
              className="itemSelector"
            />
            <ItemSelect
              active={modifier.selected_serving}
              options={pizzaServings}
              onChange={this.handleServingChange}
              className="itemSelector"
            />
            <CostDisplay cost={builderCost} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default ModifierContentBuilder;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/ModifierInput/ModifierContentBuilder.jsx